// ================= FAQ_LIST =================== //

export const FAQ_LIST = "FAQ_LIST";
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAIL = "FAQ_LIST_FAIL";

// ================= ADD_FAQ =================== //

export const ADD_FAQ = "ADD_FAQ";
export const ADD_FAQ_SUCCESS = "ADD_FAQ_SUCCESS";
export const ADD_FAQ_FAIL = "ADD_FAQ_FAIL";

// ================= GET_FAQ_BY_ID =================== //
export const GET_FAQ_BY_ID = "GET_FAQ_BY_ID";
export const GET_FAQ_BY_ID_SUCCESS = "GET_FAQ_BY_ID_SUCCESS";
export const GET_FAQ_BY_ID_FAIL = "GET_FAQ_BY_ID_FAIL";

// ================= EDIT_FAQ =================== //

export const EDIT_FAQ = "EDIT_FAQ";
export const EDIT_FAQ_SUCCESS = "EDIT_FAQ_SUCCESS";
export const EDIT_FAQ_FAIL = "EDIT_FAQ_FAIL";

// ================= DELETE_FAQ =================== //

export const DELETE_FAQ = "DELETE_FAQ";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_FAIL = "DELETE_FAQ_FAIL";
